import {
  getCurrentToken,
  getRegion,
  getEnv,
  getPartition,
} from '@adsk/acs-sc-web-platform-api';
import {
  DocsClass,
  DOCS_PRODUCTS,
  cancelAll,
  cancelRequests,
  LocaleUtil,
  FeatureUtil,
  SortingUtil,
  CANCEL_KEYS,
  SDK_FEATURES,
  FolderUtil,
  FileUtil,
  UploadUtil,
  CommonUtil,
} from '@adsk/docs-js-sdk';

const getSDK = () => {
  const instance = new DocsClass({
    region: getRegion(),
    env: getEnv(),
    partition: getPartition(),
    getToken: getCurrentToken,
    cacheExpiration: 1000 * 60 * 1, // 1 minute cache,
    buildId: 'docs_picker',
    product: DOCS_PRODUCTS.ACC,
  });
  return instance;
};

const sdk = getSDK();
const services = {
  // Docs SDK Services
  Documents: sdk.Documents,
  Folders: sdk.Folders,
  Projects: sdk.Projects,
  Search: sdk.Search,
  DerivativeService: sdk.DerivativeService,
  Upload: sdk.Upload,
};

export {
  services as default,
  cancelAll,
  cancelRequests,
  LocaleUtil,
  FeatureUtil,
  SortingUtil,
  CANCEL_KEYS,
  SDK_FEATURES,
  FolderUtil,
  FileUtil,
  UploadUtil,
  CommonUtil,
};
